import magnifierIcon from '../../../assets/images/icons/magnifier.svg'
import { trpc } from '../../../utils'
import { Scrollable } from '../../atoms'
import { Spoiler } from '../../molecules'
import * as styles from './index.css'

export const FaqView = () => {
  const { data: faq } = trpc.misc.getFaq.useQuery()

  if (!faq) {
    return 'Loading...'
  }

  return (
    <div className={styles.containerStyle}>
      <div className={styles.headerStyle}>
        <span className={styles.headerWithIcon}>
          <img
            src={magnifierIcon}
            alt=''
          />
          FAQ
        </span>
      </div>
      <Scrollable className={styles.scrollableBlock}>
        {faq.map((section) => (
          <div
            className={styles.section}
            key={section.section}
          >
            <h4 className={styles.sectionHeader}>{section.section}</h4>
            <div className={styles.sectionContentContainer}>
              {section.content.map((entity) => (
                <Spoiler
                  header={entity.header}
                  key={entity.header}
                >
                  {entity.content}
                </Spoiler>
              ))}
            </div>
          </div>
        ))}
      </Scrollable>
    </div>
  )
}
